import { Uuid } from "../../domain/model/uuid/uuid.type";
import { SectionViewModel } from "../shared/section.viewmodel";
import { TrialOverviewWeighingWeightViewModel } from "./trial-overview-weighing-weight.viewmodel";

import { TrialOverviewWeighingDateViewModel } from "./trial-overview-weighing-date.viewmodel";

export class TrialOverviewViewModel {
  constructor(
    readonly id: Uuid,
    readonly trialName: string,
    readonly penNames: string,
    readonly batchNames: string,
    readonly section: SectionViewModel,
    readonly initialWeighing: TrialOverviewWeighingDateViewModel,
    readonly firstWeighing: TrialOverviewWeighingWeightViewModel | TrialOverviewWeighingDateViewModel,
    readonly secondWeighing: TrialOverviewWeighingWeightViewModel | TrialOverviewWeighingDateViewModel,
    readonly finalWeighing: TrialOverviewWeighingWeightViewModel | TrialOverviewWeighingDateViewModel
  )
    {  }

  toString(): string {
    return `Id: ${this.id}, Name: ${this.trialName}, Section: ${this.section}, InsertionWeighing: ${this.initialWeighing}, FirstWeighing: ${this.firstWeighing}, SecondWeighing: ${this.secondWeighing}`;
  }
}
